module.exports = __webpack_public_path__ + "mainassets/img/osszes_badge.7fe5cef1.png";